import { API } from "@swivl-mono/api-helper";
import { UserInterface } from "@swivl-mono/types";
import { Spinner } from "@swivl-mono/ui";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";

interface Props {
  expiresAt?: Date;
  user?: UserInterface;
  userId?: number;
}

export default function RenewButton(props: Props) {
  const { userId, user, expiresAt } = props;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const renewLink = async () => {
    if (!user) return;
    setIsLoading(true);
    API.Users.renewTranscriptAccess(user.orgId, user.id);
    setIsLoading(false);
  };

  if (!user || isLoading) {
    return (
      <div className="RenewButton">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="TranscriptRenewButton">
      <div className="expiresText">{expiresAt ? <> Link Expires {DateTime.fromJSDate(expiresAt).toRelative()}</> : "Link Expired"}</div>
      <div className="renewButton">
        <div onClick={() => renewLink()}>Renew Link?</div>
      </div>
    </div>
  );
}
